import { useDispatch, useSelector } from 'react-redux'

import { Recharge } from '../model/balance.model'
import { fetchBalance, fetchRecharges, fetchMoreRecharges } from '../store/balance.reducer'
import {
  selectBalanceAmount,
  selectBalanceLoading,
  selectBalanceError,
  selectRecharges,
  selectRechargesLoading,
  selectRechargesError,
} from '../store/balance.selectors'

import { useBrand } from '~/brand'
import { StoreError, GrossAndNet } from '~/common/model'

interface FetchRechargesProps {
  subscriptionId: string
  startDate?: string
  endDate?: string
  sub: string
}

interface FetchMoreRechargesProps {
  subscriptionId: string
  monthsToAdd: number
  sub: string
}

interface useBalance {
  getBalance: (subscriptionId: string, provinceId: string, sub: string) => unknown
  amount?: GrossAndNet
  balanceLoading?: boolean
  balanceError?: StoreError
  getRecharges: (fetchRechargesProps: FetchRechargesProps) => unknown
  getMoreRecharges: (fetchRechargesProps: FetchMoreRechargesProps) => unknown
  recharges?: Recharge[]
  rechargesLoading?: boolean
  rechargesError?: StoreError
}

export default function useBalance(subscriptionId: string): useBalance {
  const dispatch = useDispatch()
  const { brand } = useBrand()

  return {
    getBalance: (subscriptionId: string, provinceId: string, sub: string) =>
      dispatch(fetchBalance({ brand, subscriptionId, provinceId, sub })),
    amount: useSelector(selectBalanceAmount(subscriptionId)),
    balanceLoading: useSelector(selectBalanceLoading(subscriptionId)),
    balanceError: useSelector(selectBalanceError(subscriptionId)),
    getRecharges: (fetchRechargesProps: FetchRechargesProps) =>
      dispatch(fetchRecharges({ ...fetchRechargesProps, brand })),
    getMoreRecharges: (fetchMoreRechargesProps: FetchMoreRechargesProps) =>
      dispatch(fetchMoreRecharges({ ...fetchMoreRechargesProps, brand })),
    recharges: useSelector(selectRecharges(subscriptionId)),
    rechargesLoading: useSelector(selectRechargesLoading(subscriptionId)),
    rechargesError: useSelector(selectRechargesError(subscriptionId)),
  }
}
